<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    persistent
  >
    <template v-slot:activator="{ on }">
      <v-list-item v-if="list" v-on="on">
        <v-list-item-icon>
          <v-icon small>fa-plus</v-icon>
          <v-icon>fa-drumstick-bite</v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          Perte
        </v-list-item-title>
      </v-list-item>
      <v-btn color="success" v-else-if="helper === true" v-on="on" block>
        <v-icon x-small class="mr-1">fa-plus</v-icon>
        <v-icon small left>fa-drumstick-bite</v-icon>
        Perte
      </v-btn>
      <v-btn
        color="accent"
        elevation="0"
        v-else
        v-on="on"
        :block="$vuetify.breakpoint.xsOnly"
      >
        <v-icon x-small class="mr-1">fa-plus</v-icon>
        <v-icon small left>fa-drumstick-bite</v-icon>
        Perte
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters dense>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row dense>
            <v-col>
              <j-date-picker
                v-model="transaction.date"
                label="Date de la perte"
                required
                filled
                class="no-before"
                icon=""
                inner-icon="fa-calendar"
              ></j-date-picker>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-autocomplete
                filled
                class="no-before"
                v-model="transaction.fk_product"
                :items="getProducts.filter(x => x.is_deleted === false)"
                item-text="nom"
                item-value="id"
                label="Sélectionner un produit"
                :rules="[v => !!v || `Un produit est requis`]"
                required
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <v-select
                filled
                class="no-before"
                v-model="transaction.waste_cause"
                :items="getActiveWasteCauses"
                item-text="name"
                item-value="id"
                label="Sélectionner une cause pour la perte"
                required
                :rules="[v => !!v || `Une cause est requise`]"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <j-decimal-input
                filled
                class="no-before"
                v-model="transaction.quantity"
                required
                label="Quantité"
                :suffix="selectedProductUnit"
              ></j-decimal-input>
            </v-col>
          </v-row>
        </v-form>
        <v-row align="center" v-show="loading" no-gutters>
          <v-progress-linear indeterminate color="primary"></v-progress-linear>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row align="center" justify="space-between" no-gutters>
          <v-btn
            v-if="getIsAdmin"
            :block="$vuetify.breakpoint.xsOnly"
            small
            @click="$router.push({ name: 'InventoryWasteCauseIndex' })"
          >
            Gestion des raisons de perte
            <v-icon x-small right>fa-external-link-square-alt</v-icon>
          </v-btn>
          <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :small="!$vuetify.breakpoint.xsOnly"
            :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
            color="success"
            :disabled="!valid || loading"
            @click="addWaste"
          >
            Soumettre
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import moment from "moment";
export default {
  name: "InventoryWasteDialog",
  props: {
    list: {
      type: Boolean,
      default: false
    },
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters([
      "getStoreId",
      "getProducts",
      "getActiveWasteCauses",
      "getIsAdmin"
    ]),
    selectedProductUnit() {
      if (this.transaction.fk_product) {
        const product = this.getProducts.find(
          x => x.id === this.transaction.fk_product
        );
        if (product && product.data) {
          return product.data && product.data.unite_mesure_inventory
            ? product.data.unite_mesure_inventory
            : product.data
            ? product.data.unite_mesure
            : "";
        } else {
          return "";
        }
      } else {
        return "";
      }
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      transaction: {
        fk_product: null,
        store: null,
        date: moment().format("YYYY-MM-DD"),
        comments: null,
        waste_cause: null,
        quantity: 0,
        transaction_type: 4
      }
    };
  },
  methods: {
    async addWaste() {
      if (this.valid) {
        const data = {
          ...this.transaction,
          quantity: -Math.abs(this.transaction.quantity),
          store: this.getStoreId,
          date: moment()
            .year(moment(this.transaction.date).year())
            .month(moment(this.transaction.date).month())
            .date(moment(this.transaction.date).date())
            .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
        };
        try {
          this.loading = true;
          await api.postInventoryTransaction(data);
          this.$store.dispatch("loadInventoryRecords", {
            store: this.getStoreId,
            latest: true
          });
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    }
  },
  watch: {
    async dialog(v) {
      if (v === false) {
        await this.$refs.form.reset();
        this.transaction.date = moment().format("YYYY-MM-DD");
      } else {
        this.$store.dispatch("loadWasteCauses", {
          store: this.getStoreId
        });
      }
    }
  }
};
</script>

<style></style>
